var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-input',{attrs:{"label":_vm.label,"value-key":"id","label-value":"name","placeholder":_vm.placeholder,"size":_vm.size,"required":_vm.required,"disabled":_vm.disabled},on:{"change":_vm.updated},model:{value:(_vm.ratesData),callback:function ($$v) {_vm.ratesData=$$v},expression:"ratesData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }